import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IProductParentTitleResponse, IProductParentTitleResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setParentTitleList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";

export const useProductParentTitleAPI = () => {
  const dispatch = useAppDispatch();
  const [searchResults, setSearchResults] = useState<IProductParentTitleResponseData[]>([]);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const clearSearchResults = () => {
    setSearchResults([]);
  };
  const execute = useCallback(
    async (searchID: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: IProductParentTitleResponseData = await axios
          .get(`${INVENTORY_MODULE?.PARENT_TITLE_LIST?.baseURL}?search_keyword=${searchID}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IProductParentTitleResponse>) => {
            if (res.data.status === true) {
              dispatch(setParentTitleList({ data: res.data.data }));
              setSearchResults(res.data.data);
              return res.data.data;
            } else {
              dispatch(setParentTitleList({ data: [] }));
              setSearchResults([]);
              return null;
            }
          })
          .catch((e: AxiosError) => {
            setSearchResults([]);
            captureError(e)
            return null;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return null;
      }
    },
    [dispatch],
  );
  return { searchResults, execute, clearSearchResults };
};
